(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-idg-user-guide]';

  function parseTimestamp(value) {
    var parts = String(value || '').trim().split(':');
    if (parts.length < 2 || parts.length > 3) return null;

    var numbers = parts.map(function (part) {
      return Number(part);
    });

    if (numbers.some(function (number) { return !Number.isFinite(number) || number < 0; })) return null;
    if (numbers[numbers.length - 1] >= 60) return null;
    if (parts.length === 3 && numbers[1] >= 60) return null;

    return parts.length === 3
      ? (numbers[0] * 3600) + (numbers[1] * 60) + numbers[2]
      : (numbers[0] * 60) + numbers[1];
  }

  function formatTime(seconds) {
    var total = Math.max(0, Math.floor(seconds));
    var hours = Math.floor(total / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var remainder = total % 60;
    var padded = String(remainder).padStart(2, '0');

    if (hours > 0) return hours + ':' + String(minutes).padStart(2, '0') + ':' + padded;
    return String(minutes).padStart(2, '0') + ':' + padded;
  }

  function initGuide(root) {
    if (!root || root.dataset.idgGuideReady === 'true') return;

    var video = root.querySelector('[data-guide-player] video');
    if (!video) return;

    root.dataset.idgGuideReady = 'true';

    var player = root.querySelector('.ig-guide__video-shell');
    var durationNode = root.querySelector('[data-guide-duration]');
    var fullscreenButton = root.querySelector('[data-guide-fullscreen]');
    var chapterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-guide-chapter]:not(:disabled)'));
    var chapters = chapterButtons.map(function (button) {
      return { button: button, seconds: parseTimestamp(button.dataset.guideTime) };
    }).filter(function (chapter) {
      if (chapter.seconds !== null) return true;
      chapter.button.disabled = true;
      chapter.button.setAttribute('aria-disabled', 'true');
      return false;
    }).sort(function (a, b) {
      return a.seconds - b.seconds;
    });
    var activeIndex = -1;

    function setActiveChapter(currentTime) {
      var nextIndex = -1;

      chapters.forEach(function (chapter, index) {
        if (currentTime + 0.25 >= chapter.seconds) nextIndex = index;
      });

      if (nextIndex === activeIndex) return;
      activeIndex = nextIndex;

      chapters.forEach(function (chapter, index) {
        if (index === activeIndex) chapter.button.setAttribute('aria-current', 'true');
        else chapter.button.removeAttribute('aria-current');
      });
    }

    function scrollPlayerIntoView() {
      if (!player || !window.matchMedia('(max-width: 979px)').matches) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      player.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    function seekTo(seconds) {
      function applySeek(shouldPlay) {
        var upperLimit = Number.isFinite(video.duration) ? Math.max(0, video.duration - 0.1) : seconds;
        try {
          video.currentTime = Math.min(seconds, upperLimit);
        } catch (error) {
          return;
        }
        setActiveChapter(video.currentTime);
        scrollPlayerIntoView();

        if (shouldPlay !== false) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        }
      }

      if (video.readyState >= 1) applySeek(true);
      else {
        /* Keep play() inside the user's click gesture on iOS, then seek once metadata is ready. */
        video.addEventListener('loadedmetadata', function () { applySeek(false); }, { once: true });
        var earlyPlay = video.play();
        if (earlyPlay && typeof earlyPlay.catch === 'function') earlyPlay.catch(function () {});
      }
    }

    chapters.forEach(function (chapter) {
      chapter.button.addEventListener('click', function () {
        seekTo(chapter.seconds);
      });
    });

    function updateDuration() {
      if (!durationNode || !Number.isFinite(video.duration)) return;
      var current = durationNode.textContent.trim();
      var slashIndex = current.lastIndexOf('/');
      var prefix = slashIndex >= 0 ? current.slice(0, slashIndex + 1).trim() : 'VIDEO /';
      durationNode.textContent = prefix + ' ' + formatTime(video.duration);
      chapters.forEach(function (chapter) {
        if (chapter.seconds >= video.duration) {
          chapter.button.disabled = true;
          chapter.button.setAttribute('aria-disabled', 'true');
        }
      });
      setActiveChapter(video.currentTime || 0);
    }

    video.addEventListener('loadedmetadata', updateDuration);
    video.addEventListener('timeupdate', function () {
      setActiveChapter(video.currentTime || 0);
    });
    video.addEventListener('ended', function () {
      setActiveChapter(video.duration || video.currentTime || 0);
    });

    if (video.readyState >= 1) updateDuration();

    if (fullscreenButton) {
      fullscreenButton.addEventListener('click', function () {
        var result;

        try {
          /* iOS requires the native video fullscreen call to remain in the click gesture. */
          if (video.webkitSupportsFullscreen && typeof video.webkitEnterFullscreen === 'function') {
            video.webkitEnterFullscreen();
            return;
          }
          if (typeof video.requestFullscreen === 'function') result = video.requestFullscreen();
          else if (typeof video.webkitEnterFullscreen === 'function') video.webkitEnterFullscreen();
          else if (typeof video.webkitRequestFullscreen === 'function') result = video.webkitRequestFullscreen();
        } catch (error) {
          if (typeof video.webkitEnterFullscreen === 'function') video.webkitEnterFullscreen();
        }

        if (result && typeof result.catch === 'function') {
          result.catch(function () {
            if (typeof video.webkitEnterFullscreen === 'function') video.webkitEnterFullscreen();
          });
        }
      });
    }
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) initGuide(scope);
    Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT_SELECTOR), initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
